import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Trash2, Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [msgs, setMsgs] = useState([]);
  const load = () => api.get("/contact").then((r) => setMsgs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    await api.delete(`/contact/${id}`);
    toast.success("Usunięto");
    load();
  };

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-ztk-navy dark:text-white">Wiadomości kontaktowe</h2>
      <p className="mt-1 text-sm text-muted-foreground">Zgłoszenia z formularza kontaktowego</p>
      <div className="mt-8 space-y-3">
        {msgs.length === 0 && <p className="text-sm text-muted-foreground">Brak wiadomości</p>}
        {msgs.map((m) => (
          <div key={m.id} className="rounded-xl border border-border bg-card p-5" data-testid={`admin-message-${m.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2 text-sm">
                  <span className="font-semibold text-ztk-navy dark:text-white">{m.name}</span>
                  <a href={`mailto:${m.email}`} className="flex items-center gap-1 text-ztk-blue"><Mail className="h-3.5 w-3.5" />{m.email}</a>
                  <span className="text-xs text-muted-foreground">{new Date(m.created_at).toLocaleString("pl-PL")}</span>
                </div>
                {m.subject && <p className="mt-1 text-sm font-medium">{m.subject}</p>}
                <p className="mt-2 whitespace-pre-wrap text-sm text-muted-foreground">{m.message}</p>
              </div>
              <Button size="icon" variant="ghost" onClick={() => del(m.id)} className="shrink-0 text-destructive" data-testid={`message-delete-${m.id}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
